module.exports = __webpack_public_path__ + "img/2.e5dd7bb3.webp";